import React from "react";


import {
    Col
} from "react-bootstrap";


import {
    CardComponent,
    CardTitleComponent,
    CardDescriptionComponent,
    SvgIconComponent
} from "@Components/Elements";


import "./index.scss";


type InformativeCardDecorationType = {
    decorationType: 'orderNr' | 'icon';
    decorationSource?: string;
};


interface InformativeCardComponentProps {
    cardDecoration: InformativeCardDecorationType;
    cardTitle: string;
    cardDescription?: string;
    xs?: number; xl?: number;
}


export const InformativeCardComponent:React.FC<InformativeCardComponentProps> = ({
    cardDecoration, cardTitle, cardDescription,
    xs = 12, xl
}) => {

    let CardDecorationElement = null;

    if (cardDecoration.decorationSource) {
        switch (cardDecoration.decorationType) {
            case 'orderNr':
                CardDecorationElement = <span className={'informative-card-text-decoration'}>{cardDecoration.decorationSource}</span>;
                break;
            case "icon":
                CardDecorationElement = <SvgIconComponent iconSource={cardDecoration.decorationSource} className={'informative-card-icon-decoration'} />;
                break;
        }
    }

    return (
        <CardComponent xs={xs} xl={xl} type={1} className={'informative-card-component'}>

            <Col xs={'auto'} className={'informative-card-decoration-component'}>
                {CardDecorationElement}
            </Col>

            <Col xs={'auto'} className={'informative-card-content-component'}>

                <CardTitleComponent
                    cardTitle={cardTitle}
                />

                {cardDescription &&
                <CardDescriptionComponent
                    cardDescription={cardDescription}
                />
                }

            </Col>

        </CardComponent>
    );

};


export default InformativeCardComponent;
